import { useSelector } from 'react-redux'

import { getPatient } from '~/store/reducers/patients'
import { getClientId, getPatientId } from '~/store/reducers/soap'

import { SoapHeaderMenuButton } from '../../soap-menu/SoapHeaderMenuButton'
import PatientDetailsHeader from '../../summary/patient-details/PatientDetailsHeader'

export type SoapPatientTileProps = {
  /** When set, overrides SOAP slice `clientId` (e.g. client/patient routes outside SOAP). */
  clientId?: string
  /** When set, overrides SOAP slice `patientId`. */
  patientId?: string
  /** When false, hides SOAP-only actions (header menu). Defaults to true. */
  showSoapActions?: boolean
}

export const SoapPatientTile = ({
  clientId: clientIdProp,
  patientId: patientIdProp,
  showSoapActions = true,
}: SoapPatientTileProps) => {
  const clientIdFromStore = useSelector(getClientId) ?? ''
  const patientIdFromStore = useSelector(getPatientId) ?? ''
  const clientId = clientIdProp ?? clientIdFromStore
  const patientId = patientIdProp ?? patientIdFromStore
  const patient = useSelector(getPatient(patientId))

  return (
    <PatientDetailsHeader
      actionsSlot={showSoapActions ? <SoapHeaderMenuButton /> : undefined}
      clientId={clientId}
      patient={patient}
    />
  )
}
